import { render, staticRenderFns } from "./PayCollect.vue?vue&type=template&id=5d79a410&scoped=true&"
import script from "./PayCollect.vue?vue&type=script&lang=js&"
export * from "./PayCollect.vue?vue&type=script&lang=js&"
import style0 from "./PayCollect.vue?vue&type=style&index=0&id=5d79a410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d79a410",
  null
  
)

export default component.exports